import { render, staticRenderFns } from "./ErrorPackageLimit.vue?vue&type=template&id=cf856122&scoped=true"
import script from "./ErrorPackageLimit.vue?vue&type=script&lang=js"
export * from "./ErrorPackageLimit.vue?vue&type=script&lang=js"
import style0 from "./ErrorPackageLimit.vue?vue&type=style&index=0&id=cf856122&prod&lang=scss"
import style1 from "./ErrorPackageLimit.vue?vue&type=style&index=1&id=cf856122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf856122",
  null
  
)

export default component.exports